// À La Carte Order Action Creators

import * as actionTypes from './constants';

export const setAlaCarteStep = (step) => ({
  type: actionTypes.SET_ALACARTE_STEP,
  payload: step
});

export const setBoxCount = (count) => ({
  type: actionTypes.SET_BOX_COUNT,
  payload: count
});

export const setBoxProduct = (product) => ({
  type: actionTypes.SET_BOX_PRODUCT,
  payload: product
});

export const setPackingSupplies = (supplies) => ({
  type: actionTypes.SET_PACKING_SUPPLIES,
  payload: supplies
});

export const setMovingSupplies = (supplies) => ({
  type: actionTypes.SET_MOVING_SUPPLIES,
  payload: supplies
});

export const addPackingSupply = (supply) => ({
  type: actionTypes.ADD_PACKING_SUPPLY,
  payload: supply
});

export const removePackingSupply = (supplyId) => ({
  type: actionTypes.REMOVE_PACKING_SUPPLY,
  payload: supplyId
});

export const updatePackingSupplyQuantity = (supplyId, quantity) => ({
  type: actionTypes.UPDATE_PACKING_SUPPLY_QUANTITY,
  payload: { supplyId, quantity }
});

export const addMovingSupply = (supply) => ({
  type: actionTypes.ADD_MOVING_SUPPLY,
  payload: supply
});

export const removeMovingSupply = (supplyId) => ({
  type: actionTypes.REMOVE_MOVING_SUPPLY,
  payload: supplyId
});

export const updateMovingSupplyQuantity = (supplyId, quantity) => ({
  type: actionTypes.UPDATE_MOVING_SUPPLY_QUANTITY,
  payload: { supplyId, quantity }
});

export const setDeliveryDetails = (details) => ({
  type: actionTypes.SET_DELIVERY_DETAILS,
  payload: details
});

export const setPickupDetails = (details) => ({
  type: actionTypes.SET_PICKUP_DETAILS,
  payload: details
});

export const setCustomerInfo = (info) => ({
  type: actionTypes.SET_CUSTOMER_INFO,
  payload: info
});

export const setRentalInfo = (rentalInfo) => ({
  type: actionTypes.SET_RENTAL_INFO,
  payload: rentalInfo
});

export const setLockedPickupDetails = (pickupDetails) => ({
  type: actionTypes.SET_LOCKED_PICKUP_DETAILS,
  payload: pickupDetails
});

export const setDeliveryAddressFromRental = (deliveryAddress) => ({
  type: actionTypes.SET_DELIVERY_ADDRESS_FROM_RENTAL,
  payload: deliveryAddress
});

export const setTaxRate = (taxRate) => ({
  type: actionTypes.SET_TAX_RATE,
  payload: taxRate
});

export const setExtraWork = (extraWork) => ({
  type: actionTypes.SET_EXTRA_WORK,
  payload: extraWork
});

export const setDeliveryExtraWork = (extraWork) => ({
  type: actionTypes.SET_DELIVERY_EXTRA_WORK,
  payload: extraWork
});

export const setPickupExtraWork = (extraWork) => ({
  type: actionTypes.SET_PICKUP_EXTRA_WORK,
  payload: extraWork
});

export const setOrderId = (orderId) => ({
  type: actionTypes.SET_ORDER_ID,
  payload: orderId
});

export const calculateTotal = () => ({
  type: actionTypes.CALCULATE_TOTAL
});

export const resetAlaCarteStore = () => ({
  type: actionTypes.RESET_ALACARTE_STORE
});
